import { Link } from 'react-router';
import BrandLockup from '../BrandLockup';
import Footer from '../Footer';
import useDocumentMeta from '../../hooks/useDocumentMeta';

/**
 * The shared frame for /privacy and /terms.
 *
 * A reading page rather than a marketing page: a simplified header, one
 * measured column, and a contents list that sticks alongside it on a wide
 * screen. `sections` is the single source for both the contents list and the
 * body, so the two cannot drift apart.
 */
export default function LegalPageLayout({
  title,
  lastUpdated,
  intro,
  sections,
  meta,
}) {
  useDocumentMeta(meta);

  return (
    <>
      <header className="legal-header">
        <div className="legal-header__inner">
          <Link className="legal-header__brand" to="/" aria-label="ShareShutter home">
            <BrandLockup size={26} />
          </Link>
          <Link className="text-link" to="/">
            Back to home
          </Link>
        </div>
      </header>

      <main className="legal" id="main">
        <div className="legal__inner">
          <article className="legal__doc">
            <h1 className="legal__title">{title}</h1>
            <p className="legal__updated">Last Updated: {lastUpdated}</p>

            <div className="legal__intro">{intro}</div>

            <nav className="legal__contents" aria-labelledby="contents-heading">
              <h2 className="legal__contents-title" id="contents-heading">
                Contents
              </h2>
              <ol className="legal__contents-list">
                {sections.map((section, index) => (
                  <li key={section.id}>
                    <a href={`#${section.id}`}>
                      <span className="legal__contents-number">{index + 1}</span>
                      {section.title}
                    </a>
                  </li>
                ))}
              </ol>
            </nav>

            {sections.map((section, index) => (
              <section className="legal__section" id={section.id} key={section.id}>
                <h2 className="legal__heading">
                  <span className="legal__heading-number" aria-hidden="true">
                    {index + 1}
                  </span>
                  {section.title}
                </h2>
                {section.content}
              </section>
            ))}
          </article>

          <aside className="legal__rail" aria-label="Section navigation">
            <nav className="legal__rail-inner">
              <p className="legal__rail-title">On this page</p>
              <ul className="legal__rail-list">
                {sections.map((section) => (
                  <li key={section.id}>
                    <a href={`#${section.id}`}>{section.title}</a>
                  </li>
                ))}
              </ul>
            </nav>
          </aside>
        </div>
      </main>

      <Footer />
    </>
  );
}
